
      const cdnUrl = import.meta.env.REACT_APP_MATOMO_CDN_URL;
      var _mtm = window._mtm = window._mtm || [];
      _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
      (function() {
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src=cdnUrl; s.parentNode.insertBefore(g,s);
      })();
    